/* eslint-disable react/destructuring-assignment */
import React from 'react'
import { useHistory } from 'react-router-dom'

import { makeStyles } from '@material-ui/core/styles'
import { DatePicker } from '@material-ui/pickers'
import Refresh from '@material-ui/icons/Refresh'

import Button from 'src/components/sharedComponents/CustomButtons/Button'
import CardTitle from 'src/components/sharedComponents/CardTitle'
import Total4WMarketCard from 'src/components/reports/reportsBoard/4wCards/Total4WMarketCard'

const useStyles = makeStyles(() => ({
  root: {
    '& > *': {
      color: '#fff',
    },
  },
}))

const Total4WMarketPage = props => {
  const { selectedDate, handleDateChange } = props
  const classes = useStyles()
  const history = useHistory()

  return (
    <>
      <CardTitle
        title="Total mercado 4W"
        component={
          <DatePicker
            autoOk
            variant="inline"
            views={['year']}
            className={classes.root}
            value={selectedDate}
            maxDate={new Date()}
            onChange={handleDateChange}
          />
        }
      />
      <Button link onClick={() => history.push('/reports/board')}>
        <Refresh /> Volver al Menú
      </Button>
      <Total4WMarketCard
        cardTitle="Evolución total del mercado 4W"
        selectedDate={selectedDate}
        arrayTable1={props.total}
        arrayG1={props.gTotal}
        paramG1="f0_"
        arrayTable2={props.totalCategory}
        paramT2="SUBCATEGORIA"
        arrayG2A={props.gACategory}
        arrayG2B={props.gBCategory}
        paramG2A="SUBCATEGORIA"
        arrayTable3={props.totalCompany}
        paramT3="EMPRESA"
        arrayG3A={props.gATotalCompany}
        arrayG3B={props.gBTotalCompany}
        paramG3="EMPRESA"
      />
      <Total4WMarketCard
        cardTitle="Evolución Total del Mercado por sub-categoría comercial"
        selectedDate={selectedDate}
        arrayTable1={props.totalCommercial}
        arrayG1={props.totalCommercial5GB}
        paramG1="PERIODO1"
        arrayTable2={props.totalCommercial5}
        paramT2="SEGMENTO"
        arrayG3A={props.totalCommercial4A}
        arrayG3B={props.totalCommercial4B}
        paramG2A="SEGMENTO"
        arrayTable3={props.totalCommercial6}
        paramT3="EMPRESA"
        arrayG2A={props.totalCommercial6A}
        arrayG2B={props.totalCommercial6B}
        paramG3="EMPRESA"
      />
      <Total4WMarketCard
        cardTitle="Evolución Total del Mercado por sub-categoría personales"
        selectedDate={selectedDate}
        arrayTable1={props.total4P}
        arrayG1={props.gTotal5P}
        paramG1="PERIODO1"
        arrayTable2={props.total5P}
        paramT2="SEGMENTO"
        arrayG3A={props.gTotal4AP}
        arrayG3B={props.gTotal4BP}
        paramG3="EMPRESA"
        arrayTable3={props.total6P}
        paramT3="EMPRESA"
        arrayG2A={props.gTOTAL6AP}
        arrayG2B={props.gTOTAL6BP}
        paramG2A="SEGMENTO"
      />
      <Total4WMarketCard
        cardTitle="Evolución Total del Mercado por sub-categoría Comerciales / Carga"
        selectedDate={selectedDate}
        arrayTable1={props.total7CL}
        arrayG1={props.gTotal8CL}
        paramG1="PERIODO1"
        arrayTable2={props.total8CL}
        paramT2="SUBSEGMENTO"
        arrayG3A={props.gTotal7ACL}
        arrayG3B={props.gTotal7BCL}
        paramG3="EMPRESA"
        arrayTable3={props.total9CL}
        paramT3="EMPRESA"
        arrayG2A={props.gTotal9ACL}
        arrayG2B={props.gTotal9BCL}
        paramG2A="SUBSEGMENTO"
      />
      <Total4WMarketCard
        cardTitle="Evolución Total del Mercado por sub-categoría Comerciales / Pasajeros"
        selectedDate={selectedDate}
        arrayTable1={props.total7PS}
        arrayG1={props.gTotal8PS}
        paramG1="PERIODO1"
        arrayTable2={props.total8PS}
        paramT2="SUBSEGMENTO"
        arrayG3A={props.gTotal7APS}
        arrayG3B={props.gTotal7BPS}
        paramG3="EMPRESA"
        arrayTable3={props.total9PS}
        paramT3="EMPRESA"
        arrayG2A={props.gTotal9APS}
        arrayG2B={props.gTotal9BPS}
        paramG2A="SUBSEGMENTO"
      />
    </>
  )
}

export default Total4WMarketPage
